<template>
  <CardComponent class="rcs-bubble">
    <pre>{{ value }}</pre>
  </CardComponent>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';

export default {
  name: 'RcsBubble',
  components: {
    CardComponent,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.rcs-bubble {
  border-radius: 20px 20px 20px 0;
  ::v-deep .card-body {
    padding: 0.75rem;
  }
}
</style>
